import React from "react";
import { Row } from "react-bootstrap";
import { SubscriptionCard } from "../impl/screens/components/subscription-card.component.tsx";
import { SubscriptionStatementPlans } from "../interfaces";

export const SubscriptionPlans: React.FC<SubscriptionStatementPlans> = ({ plans, signedPlan, handlerShowModalPayment }) => {
    return (
        <Row style={{ overflow: "hidden" }} className={"font-poppins my-5"}>
            {
                plans.map((plan) => {
                    if (signedPlan && plan.free && signedPlan.signedPlanId === plan.id) return null;
                    return (<SubscriptionCard plan={plan} key={plan.id} signedPlan={signedPlan} handlerShowModalPayment={handlerShowModalPayment} />)
                })
            }
        </Row >
    );
}
